import script from "./MST_001INS.vue?vue&type=script&setup=true&lang=js"
export * from "./MST_001INS.vue?vue&type=script&setup=true&lang=js"

import "./MST_001INS.vue?vue&type=style&index=0&id=2824d7ae&lang=css"

const __exports__ = script;

export default __exports__